"use client";

import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import { AutocompleteItem } from "../Autocomplete/AutocompleteItem";
import { stateLabelForCountry, stateOptionsForCountry } from "./states";
export interface StateSelectProps {
  country?: string | null;
  value?: string | null;
  onChange?: (state: string | null) => void;
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
  name?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  className?: string;
}
export function StateSelect(t0) {
  const $ = _c(18);
  const {
    country,
    value,
    onChange,
    onBlur,
    label,
    placeholder: t1,
    name,
    isRequired,
    isDisabled,
    isInvalid,
    errorMessage,
    className
  } = t0;
  const placeholder = t1 === undefined ? "Select a state or province" : t1;
  let t2;
  if ($[0] !== className || $[1] !== country || $[2] !== errorMessage || $[3] !== isDisabled || $[4] !== isInvalid || $[5] !== isRequired || $[6] !== label || $[7] !== name || $[8] !== onBlur || $[9] !== onChange || $[10] !== placeholder || $[11] !== value) {
    const options = stateOptionsForCountry(country);
    let t3;
    if ($[13] !== country || $[14] !== label) {
      t3 = label ?? stateLabelForCountry(country);
      $[13] = country;
      $[14] = label;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    let t4;
    if ($[16] !== onChange) {
      t4 = key => onChange?.(key === null ? null : String(key));
      $[16] = onChange;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    t2 = <Autocomplete className={className} errorMessage={errorMessage} isDisabled={isDisabled} isInvalid={isInvalid} isRequired={isRequired} label={t3} name={name} onBlur={onBlur} onSelectionChange={t4} placeholder={placeholder} selectedKey={value ?? null} variant="bordered">{options.map(_temp)}</Autocomplete>;
    $[0] = className;
    $[1] = country;
    $[2] = errorMessage;
    $[3] = isDisabled;
    $[4] = isInvalid;
    $[5] = isRequired;
    $[6] = label;
    $[7] = name;
    $[8] = onBlur;
    $[9] = onChange;
    $[10] = placeholder;
    $[11] = value;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
function _temp(state) {
  return <AutocompleteItem key={state}>{state}</AutocompleteItem>;
}